import { memo } from "react";
import type { CSSProperties, HTMLAttributes } from "react";

export const availableRichTextHeadingTags = ["h1", "h2", "h3", "h4"] as const;

export type RichTextHeadingTag = (typeof availableRichTextHeadingTags)[number];

export interface RichTextProps extends Omit<
	HTMLAttributes<HTMLDivElement>,
	"children"
> {
	content: string;
	alignment?: CSSProperties["textAlign"];
	tag?: "div" | "p" | "span" | RichTextHeadingTag;
}

function RichTextComponent({
	content,
	alignment,
	style,
	tag: WrapperComponent = "div",
	...props
}: RichTextProps) {
	return (
		<WrapperComponent
			{...props}
			style={{ ...style, textAlign: alignment }}
			dangerouslySetInnerHTML={{ __html: content }}
			suppressHydrationWarning
		/>
	);
}

export const RichText = memo(RichTextComponent);
